/* eslint-disable camelcase */
import MDIedit from 'src/assets/images/MDIedit.svg';
import MDItransfer from 'src/assets/images/MDItransfer.svg';
import MDIsavetemplate from 'src/assets/images/MDIsavetemplate.svg';
import MDIusageReports from 'src/assets/images/MDIusageReports.svg';
import MDIdownload from 'src/assets/images/MDIdownload.svg';
import MDItrash from 'src/assets/images/MDItrash.svg';
import MDINo_Usage from 'src/assets/images/MDINo_Usage.svg';
import MDIRequest_Invoice from 'src/assets/images/MDIRequest_Invoice.svg';
import MDIReportProcedureData from 'src/assets/images/MDIReportProcedureData.svg';
import CancelledPostponed from 'src/assets/images/CancelledPostponed.svg';
import unidPostponed from 'src/assets/images/MDINo_Usage.svg';
import CopyIcon from 'src/assets/images/CopyIcon.svg';
import qrCodeIcon from 'src/assets/images/qrCodeIcon.svg';
import i18n from 'src/i18n.js';
import {VISIBLE} from 'src/constants/appConstants';

export const QuickFilterLabels = (categoryName) => {
    switch (categoryName) {
        case i18n.t('orders.orderListFilterDropDown.drafts'):
            return [
                {
                    id: 1,
                    label: i18n.t(
                        'orders.orderQuickFilters.draftOrders.allDrafts'
                    ),
                    count: 0,
                    statusNotes: [''],
                    isExcluded: false,
                    isOrderType: true,
                    isOrderStatus: false,
                    isDefault: true,
                },
                {
                    id: 2,
                    label: i18n.t(
                        'orders.orderQuickFilters.draftOrders.usageDrafts'
                    ),
                    count: 0,
                    statusNotes: ['ZLB'],
                    isExcluded: false,
                    isOrderType: false,
                    isOrderStatus: false,
                    isDefault: false,
                },
                {
                    id: 3,
                    label: i18n.t(
                        'orders.orderQuickFilters.draftOrders.surgeryDrafts'
                    ),
                    count: 0,
                    statusNotes: ['ZLC'],
                    isExcluded: false,
                    isOrderType: false,
                    isOrderStatus: false,
                    isDefault: false,
                },
                {
                    id: 4,
                    label: i18n.t(
                        'orders.orderQuickFilters.draftOrders.equityDrafts'
                    ),
                    count: 0,
                    statusNotes: ['ZOR'],
                    isExcluded: false,
                    isOrderType: false,
                    isOrderStatus: false,
                    isDefault: false,
                },
            ];
        case i18n.t('orders.orderListFilterDropDown.usage.categoryName'):
            return [
                {
                    id: 1,
                    label: i18n.t('orders.orderQuickFilters.usageOrders.all'),
                    count: 0,
                    statusNotes: [''],
                    isExcluded: false,
                    isOrderType: false,
                    isOrderStatus: true,
                    isDefault: true,
                },
                {
                    id: 2,
                    label: i18n.t(
                        'orders.orderQuickFilters.usageOrders.draftNotSubmitted'
                    ),
                    count: 0,
                    statusNotes: [i18n.t('orders.orderQuickFilters.usageOrders.draftNotSubmitted')],
                    isExcluded: false,
                    isOrderType: false,
                    isOrderStatus: false,
                    isDefault: false,
                },
                {
                    id: 3,
                    label: i18n.t(
                        'orders.orderQuickFilters.usageOrders.awaitingPO.name'
                    ),
                    count: 0,
                    statusNotes: [
                        i18n.t('orders.orderQuickFilters.usageOrders.awaitingPO.statusNotes.paymentNeeded'),
                        i18n.t('orders.orderQuickFilters.usageOrders.awaitingPO.statusNotes.paymentInformationNeeded'),
                       i18n.t('orders.orderQuickFilters.usageOrders.awaitingPO.statusNotes.awaitingPO'),
                    ],
                    isExcluded: false,
                    isOrderType: false,
                    isOrderStatus: false,
                    isDefault: false,
                },
                {
                    id: 4,
                    label: i18n.t(
                        'orders.orderQuickFilters.usageOrders.pendingOverride.name'
                    ),
                    count: 0,
                    statusNotes: [
                        i18n.t('orders.orderQuickFilters.usageOrders.pendingOverride.statusNotes.pendingOverride'),
                        i18n.t('orders.orderQuickFilters.usageOrders.pendingOverride.statusNotes.submittedPendingPriceOverride'),
                    ],
                    isExcluded: false,
                    isOrderType: false,
                    isOrderStatus: false,
                    isDefault: false,
                },
                {
                    id: 5,
                    label: i18n.t(
                        'orders.orderQuickFilters.usageOrders.billingIssues'
                    ),
                    count: 0,
                    statusNotes: [i18n.t('orders.orderQuickFilters.usageOrders.billingIssues')],
                    isExcluded: false,
                    isOrderType: false,
                    isOrderStatus: false,
                    isDefault: false,
                },
                {
                    id: 6,
                    label: i18n.t(
                        'orders.orderQuickFilters.usageOrders.pendingInvoice.name'
                    ),
                    count: 0,
                    statusNotes: [
                        i18n.t('orders.orderQuickFilters.usageOrders.pendingInvoice.statusNotes.pendingInvoice'),
                         i18n.t('orders.orderQuickFilters.usageOrders.pendingInvoice.statusNotes.usageSubmittedPendingInvoice'),
                    ],
                    isExcluded: false,
                    isOrderType: false,
                    isOrderStatus: false,
                    isDefault: false,
                },
                {
                    id: 7,
                    label: i18n.t(
                        'orders.orderQuickFilters.usageOrders.fullyInvoiced'
                    ),
                    count: 0,
                    statusNotes: [i18n.t('orders.orderQuickFilters.usageOrders.fullyInvoiced')],
                    isExcluded: false,
                    isOrderType: false,
                    isOrderStatus: false,
                    isDefault: false,
                },
                {
                    id: 8,
                    label: i18n.t(
                        'orders.orderQuickFilters.usageOrders.cancelled'
                    ),
                    count: 0,
                    statusNotes: [ i18n.t('orders.orderQuickFilters.usageOrders.cancelled')],
                    isExcluded: false,
                    isOrderType: false,
                    isOrderStatus: false,
                    isDefault: false,
                },
                {
                    id: 9,
                    label: i18n.t(
                        'orders.orderQuickFilters.usageOrders.inProcess'
                    ),
                    count: 0,
                    statusNotes: [i18n.t('orders.orderQuickFilters.usageOrders.inProcess')],
                    isExcluded: false,
                    isOrderType: false,
                    isOrderStatus: false,
                    isDefault: false,
                },
            ];
        case i18n.t('navLink.deniedUsageOverridesLabel'):
            return [
                {
                    id: 1,
                    label: i18n.t(
                        'orders.orderQuickFilters.deniedUsageOverrides.label'
                    ),
                    count: 0,
                    statusNotes: ['orders.orderQuickFilters.deniedUsageOverrides.label'],
                    isExcluded: false,
                    isOrderType: false,
                    isOrderStatus: false,
                    isDefault: false,
                },
            ];
        case i18n.t('orders.orderListFilterDropDown.surgery.categoryName'):
            return [
                {
                    id: 1,
                    label: i18n.t(
                        'orders.orderQuickFilters.surgeryOrders.allSurgery'
                    ),
                    count: 0,
                    statusNotes: [''],
                    isExcluded: false,
                    isOrderType: false,
                    isOrderStatus: true,
                    isDefault: true,
                },
                {
                    id: 2,
                    label: i18n.t(
                        'orders.orderQuickFilters.surgeryOrders.draftNotSubmitted'
                    ),
                    count: 0,
                    statusNotes: [i18n.t('orders.orderQuickFilters.surgeryOrders.draftNotSubmitted')],
                    isExcluded: false,
                    isOrderType: false,
                    isOrderStatus: false,
                    isDefault: false,
                },
                {
                    id: 3,
                    label: i18n.t(
                        'orders.orderQuickFilters.surgeryOrders.usagePending'
                    ),
                    count: 0,
                    statusNotes: [i18n.t('orders.orderQuickFilters.surgeryOrders.usagePending')],
                    isExcluded: false,
                    isOrderType: false,
                    isOrderStatus: false,
                    isDefault: false,
                },
                {
                    id: 4,
                    label: i18n.t(
                        'orders.orderQuickFilters.surgeryOrders.partialShipped'
                    ),
                    count: 0,
                    statusNotes: [i18n.t('orders.orderQuickFilters.surgeryOrders.partialShipped')],
                    isExcluded: false,
                    isOrderType: false,
                    isOrderStatus: false,
                    isDefault: false,
                },
                {
                    id: 5,
                    label: i18n.t(
                        'orders.orderQuickFilters.surgeryOrders.shippedComplete'
                    ),
                    count: 0,
                    statusNotes: [i18n.t('orders.orderQuickFilters.surgeryOrders.shippedComplete')],
                    isExcluded: false,
                    isOrderType: false,
                    isOrderStatus: false,
                    isDefault: false,
                },
                {
                    id: 6,
                    label: i18n.t(
                        'orders.orderQuickFilters.surgeryOrders.inProcess'
                    ),
                    count: 0,
                    statusNotes: [i18n.t('orders.orderQuickFilters.equityOrders.inProcess')],
                    isExcluded: false,
                    isOrderType: false,
                    isOrderStatus: false,
                    isDefault: false,
                },
                {
                    id: 7,
                    label: i18n.t(
                        'orders.orderQuickFilters.surgeryOrders.cancelled'
                    ),
                    count: 0,
                    statusNotes: [i18n.t('orders.orderQuickFilters.equityOrders.cancelled')],
                    isExcluded: false,
                    isOrderType: false,
                    isOrderStatus: false,
                    isDefault: false,
                },
                {
                    id: 8,
                    label: i18n.t(
                        'orders.orderQuickFilters.surgeryOrders.nonUse'
                    ),
                    count: 0,
                    statusNotes: [i18n.t('orders.orderStatuses.nonUse')],
                    isExcluded: false,
                    isOrderType: false,
                    isOrderStatus: false,
                    isDefault: false,
                },
                {
                    id: 9,
                    label: i18n.t(
                        'orders.orderQuickFilters.surgeryOrders.usageCompleted'
                    ),
                    count: 0,
                    statusNotes: [i18n.t('orders.orderQuickFilters.surgeryOrders.usageCompleted')],
                    isExcluded: true,
                    isOrderType: false,
                    isOrderStatus: false,
                    isDefault: false,
                },
            ];
        case i18n.t('orders.orderTypes.MAST'):
            return [
                {
                    id: 1,
                    label: i18n.t(
                        'orders.orderQuickFilters.surgeryOrders.allSurgery'
                    ),
                    count: 0,
                    statusNotes: [''],
                    isExcluded: false,
                    isOrderType: false,
                    isOrderStatus: true,
                    isDefault: true,
                },
                {
                    id: 2,
                    label: i18n.t(
                        'orders.orderQuickFilters.surgeryOrders.draftNotSubmitted'
                    ),
                    count: 0,
                    statusNotes: [i18n.t('orders.orderQuickFilters.equityOrders.draftNotSubmitted')],
                    isExcluded: false,
                    isOrderType: false,
                    isOrderStatus: false,
                    isDefault: false,
                },
                {
                    id: 3,
                    label: i18n.t(
                        'orders.orderQuickFilters.surgeryOrders.usagePending'
                    ),
                    count: 0,
                    statusNotes: [i18n.t('orders.orderQuickFilters.surgeryOrders.usagePending')],
                    isExcluded: false,
                    isOrderType: false,
                    isOrderStatus: false,
                    isDefault: false,
                },
                {
                    id: 4,
                    label: i18n.t(
                        'orders.orderQuickFilters.surgeryOrders.partialShipped'
                    ),
                    count: 0,
                    statusNotes: [i18n.t('orders.orderQuickFilters.surgeryOrders.partialShipped')],
                    isExcluded: false,
                    isOrderType: false,
                    isOrderStatus: false,
                    isDefault: false,
                },
                {
                    id: 5,
                    label: i18n.t(
                        'orders.orderQuickFilters.surgeryOrders.shippedComplete'
                    ),
                    count: 0,
                    statusNotes: [i18n.t('orders.orderQuickFilters.surgeryOrders.shippedComplete')],
                    isExcluded: false,
                    isOrderType: false,
                    isOrderStatus: false,
                    isDefault: false,
                },
                {
                    id: 6,
                    label: i18n.t(
                        'orders.orderQuickFilters.equityOrders.inProcess'
                    ),
                    count: 0,
                    statusNotes: [i18n.t('orders.orderQuickFilters.equityOrders.inProcess')],
                    isExcluded: false,
                    isOrderType: false,
                    isOrderStatus: false,
                    isDefault: false,
                },
                {
                    id: 7,
                    label: i18n.t(
                        'orders.orderQuickFilters.equityOrders.cancelled'
                    ),
                    count: 0,
                    statusNotes: [i18n.t('orders.orderQuickFilters.equityOrders.cancelled')],
                    isExcluded: false,
                    isOrderType: false,
                    isOrderStatus: false,
                    isDefault: false,
                },
                {
                    id: 8,
                    label: i18n.t(
                        'orders.orderQuickFilters.surgeryOrders.usageCompleted'
                    ),
                    count: 0,
                    statusNotes: [i18n.t('orders.orderQuickFilters.surgeryOrders.usageCompleted')],
                    isExcluded: true,
                    isOrderType: false,
                    isOrderStatus: false,
                    isDefault: false,
                },
            ];
        case i18n.t('orders.orderListFilterDropDown.equity.categoryName'):
            return [
                {
                    id: 1,
                    label: i18n.t(
                        'orders.orderQuickFilters.equityOrders.allEquity'
                    ),
                    count: 0,
                    statusNotes: [''],
                    isExcluded: false,
                    isOrderType: false,
                    isOrderStatus: true,
                    isDefault: true,
                },
                {
                    id: 2,
                    label: i18n.t(
                        'orders.orderQuickFilters.equityOrders.draftNotSubmitted'
                    ),
                    count: 0,
                    statusNotes: [i18n.t('orders.orderQuickFilters.equityOrders.draftNotSubmitted')],
                    isExcluded: false,
                    isOrderType: false,
                    isOrderStatus: false,
                    isDefault: false,
                },
                {
                    id: 3,
                    label: i18n.t(
                        'orders.orderQuickFilters.equityOrders.pendingOverride.name'
                    ),
                    count: 0,
                    statusNotes: [
                        i18n.t('orders.orderQuickFilters.equityOrders.pendingOverride.statusNotes.pendingOverride'),
                       i18n.t( 'orders.orderQuickFilters.equityOrders.pendingOverride.statusNotes.pendingPriceOverrideApproval'),
                    ],
                    isExcluded: false,
                    isOrderType: false,
                    isOrderStatus: false,
                    isDefault: false,
                },
                {
                    id: 4,
                    label: i18n.t(
                        'orders.orderQuickFilters.equityOrders.partialShipped'
                    ),
                    count: 0,
                    statusNotes: [i18n.t('orders.orderQuickFilters.equityOrders.partialShipped')],
                    isExcluded: false,
                    isOrderType: false,
                    isOrderStatus: false,
                    isDefault: false,
                },
                {
                    id: 5,
                    label: i18n.t(
                        'orders.orderQuickFilters.equityOrders.inProcess'
                    ),
                    count: 0,
                    statusNotes: [i18n.t('orders.orderQuickFilters.equityOrders.inProcess')],
                    isExcluded: false,
                    isOrderType: false,
                    isOrderStatus: false,
                    isDefault: false,
                },
                {
                    id: 6,
                    label: i18n.t(
                        'orders.orderQuickFilters.equityOrders.shippedComplete'
                    ),
                    count: 0,
                    statusNotes: [i18n.t('orders.orderQuickFilters.equityOrders.shippedComplete')],
                    isExcluded: false,
                    isOrderType: false,
                    isOrderStatus: false,
                    isDefault: false,
                },
                {
                    id: 7,
                    label: i18n.t(
                        'orders.orderQuickFilters.equityOrders.invoiced.name'
                    ),
                    count: 0,
                    statusNotes: [i18n.t('orders.orderQuickFilters.equityOrders.invoiced.statusNotes.invoiced'),
                         i18n.t('orders.orderQuickFilters.equityOrders.invoiced.statusNotes.fullyInvoiced')],
                    isExcluded: false,
                    isOrderType: false,
                    isOrderStatus: false,
                    isDefault: false,
                },
                {
                    id: 8,
                    label: i18n.t(
                        'orders.orderQuickFilters.equityOrders.cancelled'
                    ),
                    count: 0,
                    statusNotes: [i18n.t('orders.orderQuickFilters.equityOrders.cancelled')],
                    isExcluded: false,
                    isOrderType: false,
                    isOrderStatus: false,
                    isDefault: false,
                },
            ];
        case i18n.t(
            'orders.orderListFilterDropDown.ConsignmentOrderStatus.categoryName'
        ):
            return [
                {
                    id: 1,
                    label: i18n.t(
                        'orders.orderQuickFilters.consignmentOrPendingOrders.allConsignmentOrPending'
                    ),
                    count: 0,
                    statusNotes: [''],
                    isExcluded: false,
                    isOrderType: false,
                    isOrderStatus: true,
                    isDefault: true,
                },
                {
                    id: 2,
                    label: i18n.t(
                        'orders.orderQuickFilters.consignmentOrPendingOrders.inProcess'
                    ),
                    count: 0,
                    statusNotes: [i18n.t('orders.orderQuickFilters.consignmentOrPendingOrders.inProcess')],
                    isExcluded: false,
                    isOrderType: false,
                    isOrderStatus: false,
                    isDefault: false,
                },
                {
                    id: 3,
                    label: i18n.t(
                        'orders.orderQuickFilters.consignmentOrPendingOrders.pendingOverride'
                    ),
                    count: 0,
                    statusNotes: [i18n.t('orders.orderQuickFilters.consignmentOrPendingOrders.pendingOverride'),i18n.t('orders.orderStatuses.submittedPendingPriceOverride')],
                    isExcluded: false,
                    isOrderType: false,
                    isOrderStatus: false,
                    isDefault: false,
                },
                {
                    id: 4,
                    label: i18n.t(
                        'orders.orderQuickFilters.consignmentOrPendingOrders.deliveryBlock'
                    ),
                    count: 0,
                    statusNotes: [i18n.t('orders.orderStatuses.deliveryBlock')],
                    isExcluded: false,
                    isOrderType: false,
                    isOrderStatus: false,
                    isDefault: false,
                },
                {
                    id: 5,
                    label: i18n.t(
                        'orders.orderQuickFilters.consignmentOrPendingOrders.billingBlock'
                    ),
                    count: 0,
                    statusNotes: [i18n.t('orders.orderQuickFilters.consignmentOrPendingOrders.billingBlock')],
                    isExcluded: false,
                    isOrderType: false,
                    isOrderStatus: false,
                    isDefault: false,
                },
                {
                    id: 6,
                    label: i18n.t(
                        'orders.orderQuickFilters.consignmentOrPendingOrders.pendingInvoice'
                    ),
                    count: 0,
                    statusNotes: [i18n.t('orders.orderQuickFilters.consignmentOrPendingOrders.pendingInvoice')],
                    isExcluded: false,
                    isOrderType: false,
                    isOrderStatus: false,
                    isDefault: false,
                },
                {
                    id: 7,
                    label: i18n.t(
                        'orders.orderQuickFilters.consignmentOrPendingOrders.billingIssues'
                    ),
                    count: 0,
                    statusNotes: [i18n.t('orders.orderQuickFilters.consignmentOrPendingOrders.billingIssues')],
                    isExcluded: false,
                    isOrderType: false,
                    isOrderStatus: false,
                    isDefault: false,
                },
                {
                    id: 8,
                    label: i18n.t(
                        'orders.orderQuickFilters.consignmentOrPendingOrders.billingSubmitted'
                    ),
                    count: 0,
                    statusNotes: [i18n.t('orders.orderQuickFilters.consignmentOrPendingOrders.billingSubmitted')],
                    isExcluded: false,
                    isOrderType: false,
                    isOrderStatus: false,
                    isDefault: false,
                },
                {
                    id: 9,
                    label: i18n.t(
                        'orders.orderQuickFilters.consignmentOrPendingOrders.fullyInvoiced'
                    ),
                    count: 0,
                    statusNotes: [i18n.t('orders.orderQuickFilters.consignmentOrPendingOrders.fullyInvoiced')],
                    isExcluded: false,
                    isOrderType: false,
                    isOrderStatus: false,
                    isDefault: false,
                },
                {
                    id: 10,
                    label: i18n.t(
                        'orders.orderQuickFilters.consignmentOrPendingOrders.cancelled'
                    ),
                    count: 0,
                    statusNotes: [i18n.t('orders.orderQuickFilters.consignmentOrPendingOrders.cancelled')],
                    isExcluded: false,
                    isOrderType: false,
                    isOrderStatus: false,
                    isDefault: false,
                },
            ];
        // return [
        //     {
        //         id: 1,
        //         label: 'All Consign',
        //         count: 0,
        //         statusNotes: [''],
        //         isExcluded: false,
        //         isOrderType: false,
        //         isOrderStatus: true,
        //         isDefault: true,
        //     },
        //     {
        //         id: 2,
        //         label: 'Delivery Block',
        //         count: 0,
        //         statusNotes: ['Delivery Block'],
        //         isExcluded: false,
        //         isOrderType: false,
        //         isOrderStatus: false,
        //         isDefault: false,
        //     },
        //     {
        //         id: 3,
        //         label: 'Partial Shipped',
        //         count: 0,
        //         statusNotes: ['Partial Shipped'],
        //         isExcluded: false,
        //         isOrderType: false,
        //         isOrderStatus: false,
        //         isDefault: false,
        //     },
        //     {
        //         id: 4,
        //         label: 'Billing Block',
        //         count: 0,
        //         statusNotes: ['Billing Block'],
        //         isExcluded: false,
        //         isOrderType: false,
        //         isOrderStatus: false,
        //         isDefault: false,
        //     },
        //     {
        //         id: 5,
        //         label: 'Shipped Complete',
        //         count: 0,
        //         statusNotes: ['Shipped Complete'],
        //         isExcluded: false,
        //         isOrderType: false,
        //         isOrderStatus: false,
        //         isDefault: false,
        //     },
        //     {
        //         id: 6,
        //         label: 'Fully Invoiced',
        //         count: 0,
        //         statusNotes: ['Fully Invoiced'],
        //         isExcluded: false,
        //         isOrderType: false,
        //         isOrderStatus: false,
        //         isDefault: false,
        //     },
        //     {
        //         id: 7,
        //         label: 'Cancelled',
        //         count: 0,
        //         statusNotes: ['Cancelled'],
        //         isExcluded: false,
        //         isOrderType: false,
        //         isOrderStatus: false,
        //         isDefault: false,
        //     },
        // ];

        case i18n.t('createOrderMethods.createConsigmentBilling'):
            return [
                {
                    id: 1,
                    label: i18n.t(
                        'orders.orderQuickFilters.consignmentOrPendingOrders.allConsignmentOrPending'
                    ),
                    count: 0,
                    statusNotes: [''],
                    isExcluded: false,
                    isOrderType: false,
                    isOrderStatus: true,
                    isDefault: true,
                },
                {
                    id: 2,
                    label: i18n.t(
                        'orders.orderQuickFilters.consignmentOrPendingOrders.inProcess'
                    ),
                    count: 0,
                    statusNotes: [i18n.t('orders.orderQuickFilters.consignmentOrPendingOrders.inProcess')],
                    isExcluded: false,
                    isOrderType: false,
                    isOrderStatus: false,
                    isDefault: false,
                },
                {
                    id: 3,
                    label: i18n.t(
                        'orders.orderQuickFilters.consignmentOrPendingOrders.pendingOverride'
                    ),
                    count: 0,
                    statusNotes: [i18n.t('orders.orderQuickFilters.consignmentOrPendingOrders.pendingOverride')],
                    isExcluded: false,
                    isOrderType: false,
                    isOrderStatus: false,
                    isDefault: false,
                },
                {
                    id: 4,
                    label: i18n.t(
                        'orders.orderQuickFilters.consignmentOrPendingOrders.deliveryBlock'
                    ),
                    count: 0,
                    statusNotes: [i18n.t('orders.orderStatuses.deliveryBlock')],
                    isExcluded: false,
                    isOrderType: false,
                    isOrderStatus: false,
                    isDefault: false,
                },
                {
                    id: 5,
                    label: i18n.t(
                        'orders.orderQuickFilters.consignmentOrPendingOrders.billingBlock'
                    ),
                    count: 0,
                    statusNotes: [i18n.t('orders.orderQuickFilters.consignmentOrPendingOrders.billingBlock')],
                    isExcluded: false,
                    isOrderType: false,
                    isOrderStatus: false,
                    isDefault: false,
                },
                {
                    id: 6,
                    label: i18n.t(
                        'orders.orderQuickFilters.consignmentOrPendingOrders.pendingInvoice'
                    ),
                    count: 0,
                    statusNotes: [i18n.t('orders.orderQuickFilters.consignmentOrPendingOrders.pendingInvoice')],
                    isExcluded: false,
                    isOrderType: false,
                    isOrderStatus: false,
                    isDefault: false,
                },
                {
                    id: 7,
                    label: i18n.t(
                        'orders.orderQuickFilters.consignmentOrPendingOrders.billingIssues'
                    ),
                    count: 0,
                    statusNotes: [i18n.t('orders.orderQuickFilters.consignmentOrPendingOrders.billingIssues')],
                    isExcluded: false,
                    isOrderType: false,
                    isOrderStatus: false,
                    isDefault: false,
                },
                {
                    id: 8,
                    label: i18n.t(
                        'orders.orderQuickFilters.consignmentOrPendingOrders.billingSubmitted'
                    ),
                    count: 0,
                    statusNotes: [i18n.t('orders.orderQuickFilters.consignmentOrPendingOrders.billingSubmitted')],
                    isExcluded: false,
                    isOrderType: false,
                    isOrderStatus: false,
                    isDefault: false,
                },
                {
                    id: 9,
                    label: i18n.t(
                        'orders.orderQuickFilters.consignmentOrPendingOrders.fullyInvoiced'
                    ),
                    count: 0,
                    statusNotes: [i18n.t('orders.orderQuickFilters.consignmentOrPendingOrders.fullyInvoiced')],
                    isExcluded: false,
                    isOrderType: false,
                    isOrderStatus: false,
                    isDefault: false,
                },
                {
                    id: 10,
                    label: i18n.t(
                        'orders.orderQuickFilters.consignmentOrPendingOrders.cancelled'
                    ),
                    count: 0,
                    statusNotes: [i18n.t('orders.orderQuickFilters.consignmentOrPendingOrders.cancelled')],
                    isExcluded: false,
                    isOrderType: false,
                    isOrderStatus: false,
                    isDefault: false,
                },
            ];
        case i18n.t('createOrderMethods.createConsignmentReturn'):
            return [
                {
                    id: 1,
                    label: i18n.t(
                        'orders.orderQuickFilters.consignmentReturn.allConsignmentReturn'
                    ),
                    count: 0,
                    statusNotes: [''],
                    isExcluded: false,
                    isOrderType: false,
                    isOrderStatus: true,
                    isDefault: true,
                },
                {
                    id: 2,
                    label: i18n.t(
                        'orders.orderQuickFilters.consignmentReturn.awaitingReturn'
                    ),
                    count: 0,
                    statusNotes: [i18n.t('orders.orderQuickFilters.consignmentReturn.awaitingReturn')],
                    isExcluded: false,
                    isOrderType: false,
                    isOrderStatus: false,
                    isDefault: false,
                },
                {
                    id: 3,
                    label: i18n.t(
                        'orders.orderQuickFilters.consignmentReturn.partialReturn'
                    ),
                    count: 0,
                    statusNotes: [i18n.t('orders.orderQuickFilters.consignmentReturn.partialReturn')],
                    isExcluded: false,
                    isOrderType: false,
                    isOrderStatus: false,
                    isDefault: false,
                },
                {
                    id: 4,
                    label: i18n.t(
                        'orders.orderQuickFilters.consignmentReturn.completed'
                    ),
                    count: 0,
                    statusNotes: [i18n.t('orders.orderQuickFilters.consignmentReturn.completed')],
                    isExcluded: false,
                    isOrderType: false,
                    isOrderStatus: false,
                    isDefault: false,
                },
                {
                    id: 5,
                    label: i18n.t(
                        'orders.orderQuickFilters.consignmentReturn.cancelled'
                    ),
                    count: 0,
                    statusNotes: [i18n.t('orders.orderQuickFilters.consignmentReturn.cancelled')],
                    isExcluded: false,
                    isOrderType: false,
                    isOrderStatus: false,
                    isDefault: false,
                },
            ];
        case i18n.t(
            'orders.orderListFilterDropDown.creditDebitReturns.categoryName'
        ):
            return [
                {
                    id: 1,
                    label: i18n.t(
                        'orders.orderQuickFilters.consignmentReturn.allConsignmentReturn'
                    ),
                    count: 0,
                    statusNotes: [''],
                    isExcluded: false,
                    isOrderType: true,
                    isOrderStatus: true,
                    isDefault: true,
                },
                {
                    id: 2,
                    label: i18n.t(
                        'orders.orderQuickFilters.consignmentReturn.awaitingReturn'
                    ),
                    count: 0,
                    statusNotes: [i18n.t('orders.orderQuickFilters.consignmentReturn.awaitingReturn')],
                    isExcluded: false,
                    isOrderType: false,
                    isOrderStatus: false,
                    isDefault: false,
                },
                {
                    id: 3,
                    label: i18n.t(
                        'orders.orderQuickFilters.consignmentReturn.partialReturn'
                    ),
                    count: 0,
                    statusNotes: [i18n.t('orders.orderQuickFilters.consignmentReturn.partialReturn')],
                    isExcluded: false,
                    isOrderType: false,
                    isOrderStatus: false,
                    isDefault: false,
                },
                {
                    id: 4,
                    label: i18n.t(
                        'orders.orderQuickFilters.consignmentReturn.completed'
                    ),
                    count: 0,
                    statusNotes: [i18n.t('orders.orderQuickFilters.consignmentReturn.completed')],
                    isExcluded: false,
                    isOrderType: false,
                    isOrderStatus: false,
                    isDefault: false,
                },
                {
                    id: 5,
                    label: i18n.t(
                        'orders.orderQuickFilters.consignmentReturn.cancelled'
                    ),
                    count: 0,
                    statusNotes: [i18n.t('orders.orderQuickFilters.consignmentReturn.cancelled')],
                    isExcluded: false,
                    isOrderType: false,
                    isOrderStatus: false,
                    isDefault: false,
                },
            ];
        default:
            return [];
    }
};

export const CategoryLists = (orderTypeVisibilityConfig) => [
    {
        id: 1,
        categoryName: i18n.t('orders.orderListFilterDropDown.all.categoryName'),
        orderType: 'ALL_ORDERS',
        isOrderStatus: false,
        isQuickFilter: false,
        isVisible: orderTypeVisibilityConfig?.ALL_ORDERS_Visibility === VISIBLE,
    },
    {
        id: 2,
        categoryName: i18n.t('orders.orderListFilterDropDown.drafts'),
        orderType: '20010',
        isOrderStatus: true,
        isQuickFilter: true,
        isVisible: orderTypeVisibilityConfig?.Draft_ORDERS_Visibility === VISIBLE,
    },
    {
        id: 3,
        categoryName: i18n.t(
            'orders.orderListFilterDropDown.usage.categoryName'
        ),
        orderType: 'ZLB',
        isOrderStatus: false,
        isQuickFilter: true,
        isVisible: orderTypeVisibilityConfig?.ZLB_OrderTypeVisibility === VISIBLE,
    },
    {
        id: 4,
        categoryName: i18n.t(
            'orders.orderListFilterDropDown.surgery.categoryName'
        ),
        orderType: 'ZLC',
        isOrderStatus: false,
        isQuickFilter: true,
        isVisible: orderTypeVisibilityConfig?.ZLC_OrderTypeVisibility === VISIBLE,
    },
    {
        id: 5,
        categoryName: i18n.t(
            'orders.orderListFilterDropDown.equity.categoryName'
        ),
        orderType: 'ZOR',
        isOrderStatus: false,
        isQuickFilter: true,
        isVisible: orderTypeVisibilityConfig?.ZOR_OrderTypeVisibility === VISIBLE,
    },
    {
        id: 6,
        categoryName: i18n.t(
            'orders.orderListFilterDropDown.creditDebitReturns.categoryName'
        ),
        orderType: 'ZKA,L2,KR,G2,ZRE',
        isOrderStatus: false,
        isQuickFilter: true,
        isVisible: orderTypeVisibilityConfig?.ZKA_L2_KR_G2_ZRE_OrderTypeVisibility === VISIBLE,
    },
    {
        id: 7,
        categoryName: i18n.t(
            'orders.orderListFilterDropDown.ConsignmentOrderStatus.categoryName'
        ),
        orderType: 'KB,KE',
        isOrderStatus: false,
        isQuickFilter: true,
        isVisible: orderTypeVisibilityConfig?.KB_KE_OrderTypeVisibility === VISIBLE,
    },
    // {
    //     id: 8,
    //     categoryName: 'Consignment Billing',
    //     orderType: 'KE',
    //     isOrderStatus: false,
    //     isQuickFilter: true,
    // },
    // {
    //     id: 9,
    //     categoryName: 'Consignment Return',
    //     orderType: 'ZKA',
    //     isOrderStatus: false,
    //     isQuickFilter: true,
    // },
];
export const CategoryListsWithMast = (orderTypeVisibilityConfig) => [
    {
        id: 1,
        categoryName: i18n.t('orders.orderListFilterDropDown.all.categoryName'),
        orderType: 'ALL_ORDERS',
        isOrderStatus: false,
        isQuickFilter: false,
        isVisible: orderTypeVisibilityConfig?.ALL_ORDERS_Visibility === VISIBLE,
    },
    {
        id: 2,
        categoryName: i18n.t('orders.orderListFilterDropDown.drafts'),
        orderType: '20010',
        isOrderStatus: true,
        isQuickFilter: true,
        isVisible: orderTypeVisibilityConfig?.Draft_ORDERS_Visibility === VISIBLE,
    },
    {
        id: 3,
        categoryName: i18n.t(
            'orders.orderListFilterDropDown.usage.categoryName'
        ),
        orderType: 'ZLB',
        isOrderStatus: false,
        isQuickFilter: true,
        isVisible: orderTypeVisibilityConfig?.ZLB_OrderTypeVisibility === VISIBLE,
    },
    {
        id: 4,
        categoryName: i18n.t(
            'orders.orderListFilterDropDown.surgery.categoryName'
        ),
        orderType: 'ZLC',
        isOrderStatus: false,
        isQuickFilter: true,
        isVisible: orderTypeVisibilityConfig?.ZLC_OrderTypeVisibility === VISIBLE,
    },
    {
        id: 5,
        categoryName: i18n.t('orders.orderTypes.MAST'),
        orderType: 'MAST',
        isOrderStatus: false,
        isQuickFilter: true,
        isVisible: orderTypeVisibilityConfig?.MAST_OrderTypeVisibility === VISIBLE,
    },
    {
        id: 6,
        categoryName: i18n.t(
            'orders.orderListFilterDropDown.equity.categoryName'
        ),
        orderType: 'ZOR',
        isOrderStatus: false,
        isQuickFilter: true,
        isVisible: orderTypeVisibilityConfig?.ZOR_OrderTypeVisibility === VISIBLE,
    },
    {
        id: 7,
        categoryName: i18n.t(
            'orders.orderListFilterDropDown.creditDebitReturns.categoryName'
        ),
        orderType: 'ZKA,L2,KR,G2,ZRE',
        isOrderStatus: false,
        isQuickFilter: true,
        isVisible: orderTypeVisibilityConfig?.ZKA_L2_KR_G2_ZRE_OrderTypeVisibility === VISIBLE,
    },
    {
        id: 8,
        categoryName: i18n.t(
            'orders.orderListFilterDropDown.ConsignmentOrderStatus.categoryName'
        ),
        orderType: 'KB,KE',
        isOrderStatus: false,
        isQuickFilter: true,
        isVisible: orderTypeVisibilityConfig?.KB_KE_OrderTypeVisibility === VISIBLE,
    },
    // {
    //     id: 8,
    //     categoryName: 'Consignment Billing',
    //     orderType: 'KE',
    //     isOrderStatus: false,
    //     isQuickFilter: true,
    // },
    // {
    //     id: 9,
    //     categoryName: 'Consignment Return',
    //     orderType: 'ZKA',
    //     isOrderStatus: false,
    //     isQuickFilter: true,
    // },
];
export const CategoryListsWithDeniedOverride = (orderTypeVisibilityConfig) => [
    {
        id: 1,
        categoryName: i18n.t('orders.orderListFilterDropDown.all.categoryName'),
        orderType: 'ALL_ORDERS',
        isOrderStatus: false,
        isQuickFilter: false,
        isVisible: orderTypeVisibilityConfig?.ALL_ORDERS_Visibility === VISIBLE,
    },
    {
        id: 2,
        categoryName: i18n.t('orders.orderListFilterDropDown.drafts'),
        orderType: '20010',
        isOrderStatus: true,
        isQuickFilter: true,
        isVisible: orderTypeVisibilityConfig?.Draft_ORDERS_Visibility === VISIBLE,
    },
    {
        id: 3,
        categoryName: i18n.t('navLink.deniedUsageOverridesLabel'),
        orderType: 'ZLB',
        isOrderStatus: true,
        isQuickFilter: true,
        isVisible: orderTypeVisibilityConfig?.ZLB_OrderTypeVisibility === VISIBLE,
    },
    {
        id: 4,
        categoryName: i18n.t(
            'orders.orderListFilterDropDown.usage.categoryName'
        ),
        orderType: 'ZLB',
        isOrderStatus: false,
        isQuickFilter: true,
        isVisible: orderTypeVisibilityConfig?.ZLB_OrderTypeVisibility === VISIBLE,
    },
    {
        id: 5,
        categoryName: i18n.t(
            'orders.orderListFilterDropDown.surgery.categoryName'
        ),
        orderType: 'ZLC',
        isOrderStatus: false,
        isQuickFilter: true,
        isVisible: orderTypeVisibilityConfig?.ZLC_OrderTypeVisibility === VISIBLE,
    },
    {
        id: 6,
        categoryName: i18n.t(
            'orders.orderListFilterDropDown.equity.categoryName'
        ),
        orderType: 'ZOR',
        isOrderStatus: false,
        isQuickFilter: true,
        isVisible: orderTypeVisibilityConfig?.ZOR_OrderTypeVisibility === VISIBLE,
    },
    {
        id: 7,
        categoryName: i18n.t(
            'orders.orderListFilterDropDown.creditDebitReturns.categoryName'
        ),
        orderType: 'ZKA,L2,KR,G2,ZRE',
        isOrderStatus: false,
        isQuickFilter: true,
        isVisible: orderTypeVisibilityConfig?.ZKA_L2_KR_G2_ZRE_OrderTypeVisibility === VISIBLE,
    },
    {
        id: 8,
        categoryName: i18n.t(
            'orders.orderListFilterDropDown.ConsignmentOrderStatus.categoryName'
        ),
        orderType: 'KB,KE',
        isOrderStatus: false,
        isQuickFilter: true,
        isVisible: orderTypeVisibilityConfig?.KB_KE_OrderTypeVisibility === VISIBLE,
    },
    // {
    //     id: 8,
    //     categoryName: 'Consignment Billing',
    //     orderType: 'KE',
    //     isOrderStatus: false,
    //     isQuickFilter: true,
    // },
    // {
    //     id: 9,
    //     categoryName: 'Consignment Return',
    //     orderType: 'ZKA',
    //     isOrderStatus: false,
    //     isQuickFilter: true,
    // },
];
export const CategoryListsWithDeniedOverrideAndMast = (orderTypeVisibilityConfig) => [
    {
        id: 1,
        categoryName: i18n.t('orders.orderListFilterDropDown.all.categoryName'),
        orderType: 'ALL_ORDERS',
        isOrderStatus: false,
        isQuickFilter: false,
        isVisible: orderTypeVisibilityConfig?.ALL_ORDERS_Visibility === VISIBLE,
    },
    {
        id: 2,
        categoryName: i18n.t('orders.orderListFilterDropDown.drafts'),
        orderType: '20010',
        isOrderStatus: true,
        isQuickFilter: true,
        isVisible: orderTypeVisibilityConfig?.Draft_ORDERS_Visibility === VISIBLE,
    },
    {
        id: 3,
        categoryName: i18n.t('navLink.deniedUsageOverridesLabel'),
        orderType: 'ZLB',
        isOrderStatus: true,
        isQuickFilter: true,
        isVisible: orderTypeVisibilityConfig?.ZLB_OrderTypeVisibility === VISIBLE,
    },
    {
        id: 4,
        categoryName: i18n.t(
            'orders.orderListFilterDropDown.usage.categoryName'
        ),
        orderType: 'ZLB',
        isOrderStatus: false,
        isQuickFilter: true,
        isVisible: orderTypeVisibilityConfig?.ZLB_OrderTypeVisibility === VISIBLE,
    },
    {
        id: 5,
        categoryName: i18n.t(
            'orders.orderListFilterDropDown.surgery.categoryName'
        ),
        orderType: 'ZLC',
        isOrderStatus: false,
        isQuickFilter: true,
        isVisible: orderTypeVisibilityConfig?.ZLC_OrderTypeVisibility === VISIBLE,
    },
    {
        id: 6,
        categoryName: i18n.t('orders.orderTypes.MAST'),
        orderType: 'MAST',
        isOrderStatus: false,
        isQuickFilter: true,
        isVisible: orderTypeVisibilityConfig?.MAST_OrderTypeVisibility === VISIBLE,
    },
    {
        id: 7,
        categoryName: i18n.t(
            'orders.orderListFilterDropDown.equity.categoryName'
        ),
        orderType: 'ZOR',
        isOrderStatus: false,
        isQuickFilter: true,
        isVisible: orderTypeVisibilityConfig?.ZOR_OrderTypeVisibility === VISIBLE
    },
    {
        id: 8,
        categoryName: i18n.t(
            'orders.orderListFilterDropDown.creditDebitReturns.categoryName'
        ),
        orderType: 'ZKA,L2,KR,G2,ZRE',
        isOrderStatus: false,
        isQuickFilter: true,
        isVisible: orderTypeVisibilityConfig?.ZKA_L2_KR_G2_ZRE_OrderTypeVisibility === VISIBLE,
    },
    {
        id: 9,
        categoryName: i18n.t(
            'orders.orderListFilterDropDown.ConsignmentOrderStatus.categoryName'
        ),
        orderType: 'KB,KE',
        isOrderStatus: false,
        isQuickFilter: true,
        isVisible: orderTypeVisibilityConfig?.KB_KE_OrderTypeVisibility === VISIBLE,
    },
    // {
    //     id: 8,
    //     categoryName: 'Consignment Billing',
    //     orderType: 'KE',
    //     isOrderStatus: false,
    //     isQuickFilter: true,
    // },
    // {
    //     id: 9,
    //     categoryName: 'Consignment Return',
    //     orderType: 'ZKA',
    //     isOrderStatus: false,
    //     isQuickFilter: true,
    // },
];

export const OrderTypeFilterConstant = () => [
    {
        orderType: 'ZLC',
        orderTypeName: i18n.t(
            'orders.orderListFilterDropDown.surgery.categoryName'
        ),
    },
    {
        orderType: 'ZLB',
        orderTypeName: i18n.t(
            'orders.orderListFilterDropDown.usage.categoryName'
        ),
    },
    {
        orderType: 'ZOR',
        orderTypeName: i18n.t(
            'orders.orderListFilterDropDown.equity.categoryName'
        ),
    },
    // { orderType: 'ZKA', orderTypeName: 'Consignment Pickup' },
    {
        orderType: 'KE',
        orderTypeName: i18n.t('createOrderMethods.createConsigmentBilling'),
    },
    {
        orderType: 'KB',
        orderTypeName: i18n.t('createOrderMethods.ConsignmentIssues'),
    },
    {
        orderType: 'ZKA',
        orderTypeName: i18n.t('createOrderMethods.createConsignmentReturn'),
    },
    {
        orderType: ['ZKA', 'ZRE', 'L2', 'KR', 'G2'], // namita
        orderTypeName: i18n.t(
            'orders.orderListFilterDropDown.creditDebitReturns.categoryName'
        ),
    },
];

export const ConstantOrderTypeFilter = () => [
    {
        orderType: ['ZLC'],
        orderTypeName: i18n.t(
            'orders.orderListFilterDropDown.surgery.categoryName'
        ),
    },
    {
        orderType: ['ZLB'],
        orderTypeName: i18n.t(
            'orders.orderListFilterDropDown.usage.categoryName'
        ),
    },
    {
        orderType: ['MAST'],
        orderTypeName: i18n.t('orders.orderTypes.MAST'),
    },
    {
        orderType: ['ZOR'],
        orderTypeName: i18n.t(
            'orders.orderListFilterDropDown.equity.categoryName'
        ),
    },
    {
        orderType: ['ZKA', 'ZRE', 'L2', 'KR', 'G2'],
        orderTypeName: i18n.t(
            'orders.orderListFilterDropDown.creditDebitReturns.categoryName'
        ),
    },
    {
        orderType: ['KB'],
        orderTypeName: i18n.t(
            'orders.orderListFilterDropDown.ConsignmentOrderStatus.categoryName'
        ),
    },
    {
        orderType: ['KE'],
        orderTypeName: i18n.t('createOrderMethods.createConsigmentBilling'),
    },
    // {
    //     orderType: ['ZKA'],
    //     orderTypeName: 'Consignment Return',
    // },
];

export const OrderSummaryTabs = () => [
    {
        id: 'orderBasicDetails',
        label: i18n.t('orders.orderSummaryTabs.orderSummary'),
    },
    {
        id: 'orderDetails',
        label: i18n.t('orders.orderSummaryTabs.orderDetails'),
    },
    {
        id: 'backOrders',
        label: i18n.t('orders.orderSummaryTabs.backOrders'),
    },
    {
        id: 'shipAndTrack',
        label: i18n.t('orders.orderSummaryTabs.shipAndTrack'),
    },
    {
        id: 'billingSummary',
        label: i18n.t('orders.orderSummaryTabs.billingSummary'),
    },
    {
        id: 'replenishmentRequests',
        label: i18n.t('orders.orderSummaryTabs.replenishmentRequests'),
    },
    {
        id: 'priceOverride',
        label: i18n.t('orders.orderSummaryTabs.priceOverride'),
    },
    {
        id: 'setAvailabilityPending',
        label: i18n.t('orders.orderSummaryTabs.setAvailabilityPending'),
    },
    {
        id: 'procedureData',
        label: i18n.t('orders.orderSummaryTabs.procedureData'),
    },
];

export const PricingNotes = [
    'Sed ut perspiciatis unde omnis iste natus rror sit voluptatem accusantium',
    'Doloremque audantium, totam rem aperiam',
    'Eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.',
    'Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit.',
];

export const MdiImageSource = (ctaId) => {
    switch (ctaId) {
        case 'ExportPdf':
            return MDIdownload;
        case 'CTA_002': // DELETE
            return MDItrash;
        case 'CTA_004': // CREATE TEMPLATE
        case 'CTA2': // CREATE TEMPLATE (order summary API)
            return MDIsavetemplate;
        case 'CTA_005': // EDITORDER
            return MDIedit;
        case 'CTA_007': // No usage to report
            return MDINo_Usage;
        case 'CTA_009': // Request Invoice
            return MDIRequest_Invoice;
        case 'CTA_014': // Billing Summary
            return;
        case 'CTA_018': // Report Usage
            return MDIusageReports;
        case 'CTA_020': // Transfer
            return MDItransfer;
        case 'CTA_022': // Report Procedure Data
            return MDIReportProcedureData;
        case 'CTA_024': // Cancelled/Potponed
            return CancelledPostponed;
        case 'CTA_023':
            return unidPostponed;
        case 'CTA_026': // Copy
        case 'CTA_003': // Copy (order summary API)
        case 'CTA3': // Copy (order summary API)
            return CopyIcon;
        case 'CTA_026':
            return qrCodeIcon;
        default:
            return;
    }
};

export const OrderStatuses = () => ({
    draftNotSubmitted: i18n.t('orders.orderStatuses.draftNotSubmitted'),
    paymentInformationNeeded: i18n.t(
        'orders.orderStatuses.paymentInformationNeeded'
    ),
    billingIssues: i18n.t('orders.orderStatuses.billingIssues'),
});

export const OrderTypes = () => ({
    REPLENISHMENT: i18n.t('orders.orderTypes.replenishment'),
    USAGE_TISSUE: i18n.t('orders.orderTypes.usageTissue'),
    // TISSUE_SERVICES: i18n.t('orders.orderTypes.tissueServices'),
    USAGE_NON_TISSUE: i18n.t('orders.orderTypes.usageNonTissue'),
    // NON_TISSUE: i18n.t('orders.orderTypes.nonTissue'),
    // SURGERY_ORDER: i18n.t('orders.orderTypes.surgeryOrder'),
    // EQUITY_ORDER: i18n.t('orders.orderTypes.equityOrder'),
    CONSIGNMENTADD_ORDER: i18n.t('orders.orderTypes.CONSIGNMENTADD'),
    CONSIGNMENTBILLING_ORDER: i18n.t(
        'createOrderMethods.createConsigmentBilling'
    ),
    USAGE_ORDER: i18n.t('orders.orderTypes.USAGEORDER'),
    // DEMO_ORDER: i18n.t('orders.orderTypes.DemoOrder'),
    // CAPITAL_EQUIPMENT_ORDER: i18n.t('orders.orderTypes.capitalEquipmentOrder'),
    // CONSIGNMENT_TRANSFER: i18n.t('orders.orderTypes.consignmentTransfer'),
    // WARRANTY_REPLACE: i18n.t('orders.orderTypes.warrantyReplacement'),
    // CREDIT: i18n.t('orders.orderTypes.credit'),
    // DEBIT: i18n.t('orders.orderTypes.debit'),
    // REPLENISHMENT: 'Replenishment',
    // USAGE_TISSUE: 'Usage Tissue',
    TISSUE_SERVICES: 'Tissue Services',
    // USAGE_NON_TISSUE: 'Usage Non-tissue',
    NON_TISSUE: 'Non Tissue',
    SURGERY_ORDER: i18n.t('orders.orderTypes.surgeryOrder'),
    MAST_ORDER: i18n.t('orders.orderTypes.mastOrder'),
    MAST_USAGE: 'MAST Usage',
    MAST_REPLENISHMENT: 'MAST Replenishment',
    EQUITY_ORDER: i18n.t('orders.orderTypes.equityOrder'),
    // CONSIGNMENTADD_ORDER: 'CONSIGNMENT ADD',
    // USAGE_ORDER: 'USAGE ORDER',
    DEMO_ORDER: 'Demo/Sample Order',
    CAPITAL_EQUIPMENT_ORDER: 'Capital Equipment Order',
    CONSIGNMENT_TRANSFER: 'Consignment Transfer (no Replacement)',
    WARRANTY_REPLACE: 'Warranty Replacement',
    CREDIT: 'Credit',
    DEBIT: 'Debit',
});

export const ShipTrackLabels = () => ({
    sapOrderId: i18n.t('orders.shipTrackLabels.sapOrderId'),
    trackingNoAndUrl: i18n.t('orders.shipTrackLabels.trackingNoAndUrl'),
    shippedOn: i18n.t('orders.shipTrackLabels.shippedOn'),
    shippedToLabel: i18n.t('orders.shipTrackLabels.shippedToLabel'),
    shippedToLabelInformation: i18n.t(
        'orders.shipTrackLabels.shippedToLabelInformation'
    ),
    deliveryNo: i18n.t('orders.shipTrackLabels.deliveryNo'),
    plant: i18n.t('orders.shipTrackLabels.plant'),
    freightType: i18n.t('orders.shipTrackLabels.freightType'),
    productsTitle: i18n.t('orders.shipTrackLabels.productsTitle'),
    productItemDescriptionLabel: i18n.t(
        'orders.shipTrackLabels.productItemDescriptionLabel'
    ),
    productQuantityLabel: i18n.t('orders.shipTrackLabels.productQuantityLabel'),
    salesOrgTissue: i18n.t('orders.shipTrackLabels.salesOrgTissue'),
    salesOrgNonTissue: i18n.t('orders.shipTrackLabels.salesOrgNonTissue'),
    lastUpdated: i18n.t('orders.shipTrackLabels.lastUpdated'),
    mobileProductQtyLabel: i18n.t(
        'orders.shipTrackLabels.mobileProductQtyLabel'
    ),
    setLabel: i18n.t('orders.shipTrackLabels.setLabel'),
    eaLabel: i18n.t('orders.shipTrackLabels.eaLabel'),
    tbdTitle: i18n.t('orders.shipTrackLabels.tbdTitle'),
    lotLabel: i18n.t('orders.shipTrackLabels.lotLabel'),
});

export const PriceOverrideHistoryStatus = {
    dMReset: i18n.t('orders.priceOverrideHistoryStatus.dMReset'),
    requestorReset: i18n.t('orders.priceOverrideHistoryStatus.requestorReset'),
    complete: i18n.t('orders.priceOverrideHistoryStatus.complete'),
    approved: i18n.t('orders.priceOverrideHistoryStatus.approved'),
    reassigned: i18n.t('orders.priceOverrideHistoryStatus.reassigned'),
    reassignedTo: i18n.t('orders.priceOverrideHistoryStatus.reassignedTo'),
    reassignedBy: i18n.t('orders.priceOverrideHistoryStatus.reassignedBy'),
    awaitingActionBy: i18n.t(
        'orders.priceOverrideHistoryStatus.awaitingActionBy'
    ),
    resubmitted: i18n.t('orders.priceOverrideHistoryStatus.resubmitted'),
    submitted: i18n.t('orders.priceOverrideHistoryStatus.submitted'),
    denied: i18n.t('orders.priceOverrideHistoryStatus.denied'),
    canceledBy: i18n.t('orders.priceOverrideHistoryStatus.canceledBy'),
};
